<template>
  <router-link
    :to="{
      name: 'product',
      params: { id: data.parent_id || data.id, link: data.link },
      query: { set_id: data.parent_id ? data.id : undefined },
    }"
    class="product-card no-hover"
    :class="{
      'product-card--small': small,
      'product-card--not-available': !data.availability,
    }"
    v-if="data"
  >
    <div class="product-card__top">
      <div class="product-card__top-col">
        <span
          class="product-card__tag product-card__tag--discount"
          v-if="data.join_share && data.join_share.share"
        >
          -{{ data.join_share.share.percent }}%
        </span>
        <span
          class="product-card__tag product-card__tag--sell"
          v-if="data.join_share && data.join_share.share"
        >
          распродажа
        </span>
        <span class="product-card__tag product-card__tag--new" v-if="isProductNew(data.created_at)">
          новинка
        </span>
        <span class="product-card__tag product-card__tag--hit" v-if="data.in_popular">хит</span>
      </div>
      <div class="product-card__top-col product-card__top-col--right">
        <button
          :class="{ 'product-card__favorite--active': inFavorites }"
          type="button"
          class="product-card__favorite"
          :title="inFavorites ? 'Убрать из списка желаний' : 'В список желаний'"
          @click.prevent="addToFavorites"
        >
          <IconComponent name="heart" class="icon--thick" />
        </button>
      </div>
    </div>
    <div class="product-card__image-container">
      <ImgComponent
        :head_img="data | item_img"
        width="400"
        height="400"
        contain
        class="product-card__image"
      />
    </div>
    <div class="product-card__container">
      <div class="product-card__content">
        <div v-if="data.title" :title="data.title" class="product-card__title">
          {{ data.title }}
        </div>
      </div>
      <div class="product-card__bottom">
        <div
          class="product-card__prices"
          :class="{ 'product-card__prices--not-available': !data.availability }"
        >
          <span class="product-card__price">
            {{ data.price | share_price(data) | formatPrice }}
          </span>
          <span v-if="data.join_share && data.join_share.share" class="product-card__old-price">
            {{ data.price | formatPrice }}
          </span>
        </div>
        <button
          @click.prevent="buyProduct"
          type="button"
          class="btn btn--main btn--sm product-card__cart-add"
          :class="{ active: inCart }"
          v-if="data.availability"
        >
          <IconComponent v-if="inCart" name="tick" class="icon--thick" />
          <IconComponent v-else name="bag-2" class="icon--thick" />
        </button>
      </div>
      <div v-if="!data.availability" class="product-card__not-available">Нет в наличии</div>
    </div>
  </router-link>
</template>

<script>
import LoginModal from "components/modals/components/LoginModal.vue";
import IconComponent from "components/IconComponent.vue";
// import product from "../../mixins/product";

export default {
  name: "ProductCardComponent",
  props: {
    data: Object,
    small: Boolean,
  },
  // mixins: [product],
  data() {
    return {
      loading: false,
      count: 1,
    };
  },
  computed: {
    averageReviewsMark() {
      if (this.data && this.data.reviews && this.data.reviews.length) {
        let length = this.data.reviews.length;
        return Math.floor(this.data.reviews.map((r) => parseInt(r.mark)).reduce((a, b) => a + b, 0) / length);
      }
      return 0;
    },
    inFavorites() {
      return this.$store.state.auth.favorites.includes(this.data.id);
    },
    isRegistered() {
      return !!this.$store.state.apollo_token || this.$store.state.auth.user;
    },
    inCart() {
      return this.data && !!this.$store.state.auth.cart.find((c) => c.item?.id === this.data?.id);
    },
    needVariationSelect() {
      if (this.data.product_sets && this.data.product_sets.length) {
        return !this.data.product_sets.find((item) => item.id === this.data.id);
      }
      return false;
    },
  },
  methods: {
    buyProduct() {
      if (this.data.product_sets && this.data.product_sets.length) {
        this.$router.push({ name: "product", params: { id: this.data.id } });
      } else {
        this.cartAdd();
      }
    },
    cartAdd() {
      // если вариации есть, но ни одна не выбрана
      if (this.needVariationSelect) {
        this.$notify({
          title: "Внимание",
          text: "Выберите, пожалуйста, модель товара",
          duration: 3000,
          speed: 200,
          type: "warn",
        });
      } else {
        // если такого товара нет в корзине, то добавляем
        if (!this.inCart) {
          this.$store.state.auth.cart.unshift({
            count: this.count,
            item: this.data,
          });
          // this.$notify({
          //   title: "Добавлено в корзину",
          //   type: "success",
          // });
        } else {
          this.$router.push({ name: "cart" });
        }
        if (this.isRegistered && !this.loading) {
          this.$store
            .dispatch("CART_ADD_ITEMS", {
              apollo: this.$apollo,
              variables: {
                items: [
                  {
                    id: this.data.id,
                    count: this.count,
                  },
                ],
              },
            })
            .then(() => {
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              console.error(error);
            });
        }
      }
    },
    async addToFavorites() {
      if (this.isRegistered) {
        let index = this.$store.state.auth.favorites.indexOf(this.data.id);
        if (index !== -1) {
          this.$store.state.auth.favorites.splice(index, 1);
        } else {
          this.$store.state.auth.favorites.push(this.data.id);
        }
        await this.$store.dispatch("FAVORITE_CREATE_OR_DELETE", {
          apollo: this.$apollo,
          variables: {
            item_id: this.data.id,
          },
        });
      } else {
        this.showLoginModal();
      }
    },
    isProductNew(date) {
      let oneDay = 1000 * 60 * 60 * 24;
      return date ? Math.floor((Date.now() - new Date(date).getTime()) / oneDay) <= 14 : false;
    },
    showLoginModal() {
      this.$store.state._modals.push({
        component: LoginModal,
        options: {},
      });
    },
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/maxlines.styl"
.product-card {
  background: var(--white);
  border-radius: var(--small_radius);
  display inline-flex
  flex-direction column
  position relative
  border: 1px solid var(--gray);
  color: var(--dark)
  width 100%
  height: 100%
  cursor: pointer;
  transition var(--transition)
  +above(1201px) {
    &:hover {
      box-shadow: 0 15px 40px var(--black_o1);
      transform scale(1.1)
    }
  }

	&--not-available {
		filter brightness(0.95)
	}

  &__favorite {
    border-radius: var(--small_radius);
    border none
    background var(--white)
    cursor pointer
    padding 7px
    z-index 1
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition var(--transition)

    &:hover {
      background var(--gray)

      .icon svg path {
        stroke var(--main-color-75)
      }
    }

    &.product-card__favorite--active {
      .icon svg path {
        stroke var(--main-color-75)
        fill var(--main-color-75)
      }
    }

    .icon {
      width 16px
      height 16px

      svg path {
        stroke var(--main-color)
        transition var(--transition)
      }
    }
  }

  &__top {
    absolute left top
    width 100%
    display flex
    justify-content space-between
    align-items flex-start
    z-index 2
    padding 10px
  }

  &__top-col--right {
    align-items flex-end
  }

  &__top-col {
    display flex
    flex-direction column
    align-items flex-start
    justify-content flex-start
    gap 6px
  }

  &__tag {
    font-size: 10px;
    line-height: 110%
    padding 3px 7px
    border-radius: var(--small_radius)
    color var(--white)

    &--new {
      background var(--green)
    }

    &--discount {
      background var(--yellow)
      color: var(--main-color)
      font-weight 700
    }

    &--hit {
      background var(--purple)
    }

    &--sell {
      background var(--red)
    }
  }

  &__size {
    background: var(--white);
    color: var(--body_color_muted);
    border: 1px solid var(--blue-400);
  }

  &--small &__image {
    height 200px
    min-height 200px
    +below(860px) {
      height 200px
      min-height 200px
    }
  }

  &__image {
    object-fit contain
    object-position center
    border-radius: var(--main_radius);
    height 100vh
    max-height 170px
  }

  &__image-hover {
    absolute left top right bottom
    margin auto
    width: 100%;
    height: 100%;
    border-radius: var(--main_radius);
    display flex
    align-items center
    justify-content center
    opacity 0
    transition opacity var(--transition)
    background: rgba(80, 92, 103, 0.8);

    a {
      width 100%
      height 100%
      absolute left top
    }

    .btn {
      z-index 1
    }
  }

  &__image-container {
    position relative
    background: none;
    border: none;
    padding 10px
    border-bottom 1px dashed var(--gray)
    overflow hidden

    &:hover ^[0]__image-hover {
      opacity 1
    }
  }

  &__container {
    display flex
    flex-direction column
    gap 10px
    flex-grow 1
    padding 10px
  }

  &__content {
    display flex
    flex-direction column
    gap 8px
  }

  &__reviews {
    display inline-flex
    align-items center
    justify-content flex-start
    gap 8px
  }

  &__reviews-stars {
    display inline-flex
    align-items flex-start
    justify-content flex-start
  }

  &__reviews-star {
    width 14px
    height 14px

    &:not(&--filled) {
      svg path {
        fill transparent
        stroke var(--yellow)
      }
    }

    &--filled {
      svg path {
        fill var(--yellow)
      }
    }
  }

  &__reviews-count {
    font-weight: normal;
    font-size: 0.75em;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: var(--body-color-muted);
  }

  &__title {
    font-weight: normal;
    font-size: 0.875em;
    line-height: 145%;
    height 40px
    maxlines(2)
  }

  &__company {
    font-weight: normal;
    font-size: 0.875em;
    line-height: 20px;
    color: var(--body-color-muted);
  }

  &--small &__bottom {
    +below(540px) {
      flex-direction column
      flex: 1;

      .btn {
        width 100%
        flex-shrink: 0;
        +below(540px) {
          justify-content center
        }
      }
    }
  }

  &__bottom {
    display flex
    align-items center
    justify-content space-between
    gap 16px
    margin-top auto
  }

  &--small &__prices {
    +below(540px) {
      width: 100%;
      flex-direction: revert;
      justify-content: flex-start;
      align-items: center;
      gap 4px
    }
  }

  &__prices {
    display flex
    flex-direction column
    align-items flex-start
    justify-content center

		&--not-available {
			flex-direction row
			gap: 10px
		}
  }

  &__price {
    font-weight: 700;
    font-size: 1.125em;
    line-height: 90%;
    white-space nowrap
  }

  &__cart-add {
    &.active {
      background var(--main-color-75)
    }
  }

  &__old-price {
    font-weight: normal;
    font-size: 0.75em;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-decoration-line: line-through;
    color: var(--gray-300);
  }

	&__not-available {
		font-weight 500
	}
}
</style>
